import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { CheckoutContext } from "contexts/Checkout";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import SeeExample from "../SeeExample";
import styles from "./styles";

const PartnershipDataBundle = () => {
  const { addOnItems, applyAddOnLoading } = useContext(CheckoutContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.partnership_data,
  );

  const addToOrderButton = exists ? (
    <Box sx={{ px: 2, fontSize: 10, color: "green.main" }}>
      <strong>
        Added <Box component="i" className="fa-regular fa-check" />
      </strong>
    </Box>
  ) : (
    <LoadingButton
      disableElevation
      fullWidth
      variant="contained"
      sx={{ px: 2, ml: 1 }}
      loading={applyAddOnLoading === AddOnItemName.partnership_data}
      onClick={() =>
        applyAddOnItem({
          name: AddOnItemName.partnership_data,
          quantity: 1,
        })
      }
    >
      + Add Partnership Data
    </LoadingButton>
  );

  return (
    <Grid sx={styles.card}>
      <Box sx={styles.enhance}>Enhance Your Plan</Box>
      <Typography variant="h6" gutterBottom>
        Make it a Bundle: Partnership Data 🌟
      </Typography>

      <Typography
        component="div"
        sx={{ color: "green.main", fontSize: 16, fontWeight: 600, mb: 2 }}
        gutterBottom
      >
        $8.00/mo{" "}
        <Box component="span" sx={styles.saveBundle}>
          SAVE 20%
        </Box>
        <SeeExample />
      </Typography>
      <Typography>
        See if they pay or just offer gifted products, when they last
        collaborated, where they operate, and if their contacts are verified or
        responsive.
      </Typography>

      <Grid item xs={12} sx={{ mt: 2, ml: -2 }}>
        {addToOrderButton}
      </Grid>
    </Grid>
  );
};

export default PartnershipDataBundle;
